import { useEffect } from 'react';

import {
    resetCompanionHeartbeat,
    startCompanionHeartbeat,
} from 'flow/companion/companion-heartbeat';
import { isCompanionSignallingSurface } from 'flow/companion/companion-utils';
import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import { selectDesignatedCompanionDeviceId } from 'flow/selectors/app-selectors';
import { selectCompanionHeartbeatEnabled } from 'flow/selectors/companion-selectors';

const CompanionHeartbeat = () => {
    const dispatch = useAppDispatch();
    const signallingSurface = useAppSelector(isCompanionSignallingSurface);
    const designatedDeviceId = useAppSelector(
        selectDesignatedCompanionDeviceId,
    );
    const heartbeatEnabled = useAppSelector(selectCompanionHeartbeatEnabled);

    useEffect(() => {
        if (!heartbeatEnabled || !signallingSurface || !designatedDeviceId) {
            dispatch(resetCompanionHeartbeat());
            return undefined;
        }

        return dispatch(startCompanionHeartbeat());
    }, [dispatch, heartbeatEnabled, signallingSurface, designatedDeviceId]);

    return null;
};

export default CompanionHeartbeat;
